// import React, { useState } from 'react';
// //import axios from 'axios';
// import { Link, useNavigate } from "react-router-dom";
// import { postRequest } from "../../services/api";

// const LoginPage: React.FC = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [msgInfo, setMsgInfo] = useState<string | null>(null);
//   const navigate = useNavigate();

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     try {
//       const response = await postRequest("/auth/login", {
//         email,
//         password
//       });

//       const { token, user } = response.data;
//       localStorage.setItem("token", token);
//       localStorage.setItem("user", JSON.stringify(user));

//       setMsgInfo("Login Successful!");
//       navigate("/dashboard"); // redirect to dashboard on successful login
//       window.location.reload();

//     } catch (err: any) {
//       console.error("Login failed", err);
//       setMsgInfo("Invalid email or password. Please try again.");
//     }
//   };

//   return (
//     <div className="container">
//       <br />
//       <section>
//         <div className="px-4 py-5 px-md-5 text-center text-lg-start styling">
//           <div className="container">
//             <div className="row gx-lg-5 align-items-center">

//               <div className="col-lg-5 mb-5 mb-lg-0">

//                 {msgInfo && (
//                   <div className="alert alert-info">
//                     {msgInfo}
//                   </div>
//                 )}

//                 <div className="card" style={{ boxShadow: "10px 10px 10px lightgrey" }}>
//                   <div className="card-body py-5 px-md-5">

//                     <form onSubmit={handleSubmit}>

//                       <div className="form-outline mb-4">
//                         <input
//                           type="email"
//                           className="form-control"
//                           placeholder="Enter Your Email"
//                           required
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                         />
//                       </div>

//                       <div className="form-outline mb-4">
//                         <input
//                           type="password"
//                           className="form-control"
//                           placeholder="Enter Password"
//                           required
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                         />
//                       </div>

//                       <button type="submit" className="btn btn-primary btn-block mb-4">
//                         Login
//                       </button>

//                       <div className="d-flex justify-content-between">
//                         <Link to="/forgot-password" className="small">Forgot password?</Link>
//                       </div>

//                       <p className="mt-3">Don't have an account?
//                         <Link to="/register" className="link-info ms-1"> Register here</Link>
//                       </p>

//                     </form>

//                   </div>
//                 </div>
//               </div>

//               <div className="col-lg-7 mb-5 mb-lg-0">
//                 <h2 className="my-5 display-3 fw-bold ls-tight" style={{ fontSize: "3.5rem" }}>
//                   Join acadebility <br />
//                   <span className="text-primary">and learn with us</span>
//                 </h2>
//               </div>

//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default LoginPage;
import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { postRequest } from "../../services/api";
import "./LoginPage.css";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [msgInfo, setMsgInfo] = useState<string | null>(null);
  const [msgType, setMsgType] = useState<'success' | 'error'>('error');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMsgInfo(null);
    try {
      const response = await postRequest("/auth/login", { email, password });
      const { token, user } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      setMsgType('success');
      setMsgInfo("Login successful! Redirecting...");
      setTimeout(() => { navigate("/dashboard"); window.location.reload(); }, 800);
    } catch (err: any) {
      setMsgType('error');
      setMsgInfo("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const FEATURES = [
    { icon: "🎯", title: "500+ Test Series",      desc: "JEE, NEET, UPSC, Banking, SSC & more" },
    { icon: "❓", title: "10,000+ MCQ Questions", desc: "Topic-wise practice with instant feedback" },
    { icon: "📊", title: "Smart Analytics",        desc: "Track progress & identify weak areas" },
    { icon: "🏆", title: "All-India Rankings",     desc: "Compete with 1 Lakh+ aspirants" },
  ];

  return (
    <div className="auth-page">
      {/* ── Left panel: branding + features ── */}
      <div className="auth-left">
        <div className="auth-left-inner">
          <Link to="/" className="auth-logo">
            <span className="auth-logo-mark">A</span>
            <span className="auth-logo-text">cadebility</span>
          </Link>

          <div className="auth-headline">
            <h1>Welcome back,<br /><span className="auth-accent">keep learning.</span></h1>
            <p className="auth-tagline">
              Log in to access your tests, track progress and stay ahead of the competition.
            </p>
          </div>

          <div className="auth-features">
            {FEATURES.map(f => (
              <div className="auth-feat-item" key={f.title}>
                <span className="auth-feat-icon">{f.icon}</span>
                <div>
                  <div className="auth-feat-title">{f.title}</div>
                  <div className="auth-feat-desc">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="auth-testimonial">
            <p>"Acadebility helped me crack JEE Mains in my first attempt. The mock tests are spot-on!"</p>
            <span>— Rohan K., JEE 2024 AIR 412</span>
          </div>
        </div>

        {/* Decorative blobs */}
        <div className="auth-blob auth-blob-1" />
        <div className="auth-blob auth-blob-2" />
      </div>

      {/* ── Right panel: form ── */}
      <div className="auth-right">
        <div className="auth-form-card">
          <div className="auth-form-header">
            <h2 className="auth-form-title">Sign in</h2>
            <p className="auth-form-sub">Enter your credentials to continue</p>
          </div>

          {msgInfo && (
            <div className={`auth-alert auth-alert-${msgType}`}>
              {msgType === 'success'
                ? <span>✅</span>
                : <span>⚠️</span>}
              {msgInfo}
            </div>
          )}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="auth-label">Email address</label>
              <div className="auth-input-wrap">
                <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
                <input
                  type="email"
                  className="auth-input"
                  placeholder="you@example.com"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="auth-field">
              <div className="auth-label-row">
                <label className="auth-label">Password</label>
                <Link to="/forgot-password" className="auth-forgot">Forgot password?</Link>
              </div>
              <div className="auth-input-wrap">
                <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <input
                  type={showPwd ? "text" : "password"}
                  className="auth-input"
                  placeholder="Enter your password"
                  required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <button type="button" className="auth-pwd-toggle" onClick={() => setShowPwd(p => !p)} tabIndex={-1}>
                  {showPwd
                    ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                    : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  }
                </button>
              </div>
            </div>

            <button type="submit" className="auth-btn-primary" disabled={loading}>
              {loading
                ? <><span className="auth-spinner" /> Signing in…</>
                : "Sign in →"
              }
            </button>
          </form>

          <p className="auth-switch">
            Don't have an account?{" "}
            <Link to="/register" className="auth-switch-link">Create one free</Link>
          </p>

          <div className="auth-divider"><span>or continue with</span></div>

          <div className="auth-social-row">
            <button className="auth-social-btn" type="button">
              <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#EA4335" d="M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582L19.91 3C17.782 1.145 15.055 0 12 0 7.27 0 3.198 2.698 1.24 6.65l4.026 3.115z"/><path fill="#34A853" d="M16.04 18.013c-1.09.703-2.474 1.078-4.04 1.078a7.077 7.077 0 0 1-6.723-4.777l-4.04 3.067A11.965 11.965 0 0 0 12 24c2.933 0 5.735-1.043 7.834-3l-3.793-2.987z"/><path fill="#4A90E2" d="M19.834 21c2.195-2.048 3.62-5.096 3.62-9 0-.71-.109-1.473-.272-2.182H12v4.637h6.436c-.317 1.559-1.17 2.766-2.395 3.558L19.834 21z"/><path fill="#FBBC05" d="M5.277 14.268A7.12 7.12 0 0 1 4.909 12c0-.782.125-1.533.357-2.235L1.24 6.65A11.934 11.934 0 0 0 0 12c0 1.92.445 3.73 1.237 5.335l4.04-3.067z"/></svg>
              Google
            </button>
            <button className="auth-social-btn" type="button">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              Facebook
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
